import { COLORS, FlexView } from '@cuemath/comps';
import { Button, Dropdown, Text } from '@cuemath/web-comps';
import React, { useState } from 'react';
import styled from 'styled-components';
import {
  STUDENT_TRANSFER_REASONS_OPTIONS,
  TRANSFER_REASONS,
} from 'constants/student-transfer';
import { reasonBasedWarningMessage } from 'utils/student-transfer';
import { usePatchStudentTransferReasonUpdate } from '../../actions/student-transfer/transfer-reason-update';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { closeModal } from 'actions/modal';

const Wrapper = styled(FlexView)`
  height: 100%;
  gap: 48px;
`;

const InfoContainer = styled(FlexView)`
  gap: 24px;
`;

const DropdownWrapper = styled.div`
  width: 320px;
`;

const DropdownWarningMessage = styled(Text)`
  padding: 0 16px;
`;

const ButtonWrapper = styled(Button)`
  align-self: center;
`;

const TransferReasonUpdate = ({
  transferReason,
  studentDirectTransferId,
  actions,
  refreshData,
}) => {
  const [selectedReason, setSelectedReason] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const warningMessage = transferReason && reasonBasedWarningMessage(selectedReason);

  const handleOnStudentTransferReasonUpdate = __ERROR__ => {
    if (__ERROR__) {
      setErrorMessage(__ERROR__);
    } else {
      setErrorMessage('');

      actions.closeModal();

      if (typeof refreshData === 'function') {
        refreshData();
      }
    }
  };

  const {
    patch: patchStudentTransferReason,
    isProcessing,
  } = usePatchStudentTransferReasonUpdate({
    onComplete: handleOnStudentTransferReasonUpdate,
  });

  const handleOnReasonSelection = value => {
    setSelectedReason(value);
    setErrorMessage('');
  };

  const handleOnConfirm = () => {
    const { id: updatedReason } =
      STUDENT_TRANSFER_REASONS_OPTIONS.find(reason => reason.label === selectedReason) ||
      {};

    if (updatedReason && studentDirectTransferId) {
      patchStudentTransferReason(studentDirectTransferId, {
        reason: updatedReason,
      });
    }
  };

  return (
    <Wrapper gap={24} gutter={24} justifyContent="space-between">
      <InfoContainer>
        <InfoContainer flexDirection="row" alignItems="center">
          <Text variant="body1">Previous reason:</Text>
          <Text variant="body1Medium">{TRANSFER_REASONS[transferReason]}</Text>
        </InfoContainer>

        <DropdownWrapper>
          Updated reason:
          <Dropdown
            options={STUDENT_TRANSFER_REASONS_OPTIONS.filter(
              reason => reason.id !== transferReason,
            )}
            width="320px"
            height="max-content"
            placeholder="Reason for transfer"
            type="primary"
            onChange={value => handleOnReasonSelection(value)}
            value={selectedReason}
          />
          <DropdownWarningMessage variant="body3">
            {warningMessage}
          </DropdownWarningMessage>
        </DropdownWrapper>

        <Text color={COLORS.RED}>{errorMessage}</Text>
      </InfoContainer>

      <ButtonWrapper
        label="Confirm"
        isDisabled={!selectedReason}
        onClick={handleOnConfirm}
        isBusy={isProcessing}
      />
    </Wrapper>
  );
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ closeModal }, dispatch),
});

export default connect(null, mapDispatchToProps)(TransferReasonUpdate);
